export const ACCOUNT_CRITICAL_RESOURCE_AUTH_ACTION = "MonarchCriticalResourceAuthRemediation";
